export default __webpack_public_path__ + "static/media/9636528661ae2682c8e5e19150e67772.jpg";